/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Ivory_Bird_PantInputs */

const en_happy_ivory_bird_pant = /** @type {(inputs: Happy_Ivory_Bird_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for result calculation to begin.`)
};

const de_happy_ivory_bird_pant = /** @type {(inputs: Happy_Ivory_Bird_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartet auf den Start der Ergebnisberechnung.`)
};

/**
* | output |
* | --- |
* | "Waiting for result calculation to begin." |
*
* @param {Happy_Ivory_Bird_PantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_ivory_bird_pant = /** @type {((inputs?: Happy_Ivory_Bird_PantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Ivory_Bird_PantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_ivory_bird_pant(inputs)
	return de_happy_ivory_bird_pant(inputs)
});